import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";

function handleRemoveTagRequest(
  project: Identifiable<Project>,
  { removableId, tag }: Boundaries["removeTag"]["request"],
): Identifiable<Project> {
  return project.uuid === removableId
    ? {
        ...project,
        tags: project.tags.filter(({ name }) => name !== tag.name),
      }
    : project;
}

function handleRemoveTagSuccess(
  project: Identifiable<Project>,
  { removableId, tag }: Boundaries["removeTag"]["success"],
): Identifiable<Project> {
  return project.uuid === removableId
    ? {
        ...project,
        tags: project.tags.filter(({ name }) => name !== tag.name),
      }
    : project;
}

function handleRemoveTagFailure(
  project: Identifiable<Project>,
  { removableId, tag }: Boundaries["removeTag"]["failure"],
): Identifiable<Project> {
  return project.uuid === removableId
    ? {
        ...project,
        tags: project.tags ? [...project.tags, tag] : [tag],
      }
    : project;
}

export {
  handleRemoveTagRequest,
  handleRemoveTagSuccess,
  handleRemoveTagFailure,
};
